import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { DownFillIcon } from '~svg';
import PropTypes from 'prop-types';
import './darkPopOver.scss';
const DarkPopOver = (props) => {
  const {
    handleChange,
    options: { data = [], title = 'name', isMultiLanguage = false },
    className,
    // label,
    icon,
    boxColor,
    boxSelectedColor,
    selectedValue = '',
    style,
    language: { name = 'en' },
    popOverTop,
    placement = 'end',
    reset = false,
    labelClassName,
    isOpenAction,
    DarkPopOverStatus = () => {},
  } = props;
  const [selected, setSelected] = useState(
    data.length ? data[0][title] || '' : '',
  );
  const [showCollapse, setShowCollapse] = useState(false);
  useEffect(() => {
    setSelected(data.length ? data[0][title] || '' : '');
  }, [data]);

  useEffect(() => {
    if (selectedValue !== '') {
      setSelected(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    setSelected(data.length ? data[0][title] || '' : '');
  }, [reset]);

  useEffect(() => {
    if (showCollapse && isOpenAction) {
      setShowCollapse(false);
    }
  }, [isOpenAction]);

  useEffect(() => {
    DarkPopOverStatus(showCollapse);
  }, [showCollapse]);

  return (
    <div
      className={`filter-panel-container h-100  d-flex justify-content-center align-items-center ${className} `}
    >
      <div
        className={`filter-design border col-11 h-100 px-sm-3 px-2 ${boxColor} `}
        onClick={() => setShowCollapse(!showCollapse)}
        data-toggle="collapse"
        data-target="#collapseDropDown"
        aria-expanded="true"
        aria-controls="collapseDropDown"
      >
        {icon}
        {isMultiLanguage ? (
          <span
            className={`flex-fill text-center px-sm-3 px-xs-2 px-1 text-nowrap font-xl-small font-md-smaller font-xsmall text-truncate ${labelClassName}`}
          >
            {selected[name]}
          </span>
        ) : (
          <span
            className={`flex-fill text-center px-sm-3 px-xs-2 px-1 text-nowrap font-xl-small font-md-smaller font-xsmall text-truncate ${labelClassName}`}
          >
            <FormattedMessage id={selected} />
          </span>
        )}
        <DownFillIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
      </div>
      <div
        className={`d-flex justify-content-sm-center ${
          placement === 'center'
            ? 'justify-content-center'
            : 'justify-content-end'
        } align-items-center position-absolute w-100`}
        style={{ top: popOverTop }}
      >
        {showCollapse ? (
          <div
            style={{ zIndex: 10 }}
            id="collapseDropDown"
            className={`p-0 ${boxColor} ${style} col-11 m-2 dropdown-menu font-xl-normal font-sm-msmall font-smaller bg-white border datepickerDropDown-position shadow show`}
          >
            {data.map((item, itemIndx) => (
              <button
                name={`popover-button-${itemIndx}`}
                id={`popover-button-${itemIndx}`}
                key={`popover-${itemIndx}`}
                className={`p-2 font-sm-normal font-msmall text-dark ${
                  JSON.stringify(selected) == JSON.stringify(item[title])
                    ? ` ${boxSelectedColor} `
                    : 'bg-white'
                }
              ${
                itemIndx == data.length - 1 &&
                'default-border-bottom-radius-small'
              }
              ${itemIndx == 0 && 'default-border-top-radius-small'}`}
                onClick={() => {
                  setSelected(item[title]);
                  setShowCollapse(false);
                  handleChange(item);
                }}
              >
                {isMultiLanguage ? (
                  item[title][name]
                ) : (
                  <FormattedMessage id={item[title]} />
                )}
              </button>
            ))}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
DarkPopOver.propTypes = {
  options: PropTypes.object,
  handleChange: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.any,
  language: PropTypes.object,
  boxColor: PropTypes.string,
  boxSelectedColor: PropTypes.string,
  selectedValue: PropTypes.string || PropTypes.object,
  popOverTop: PropTypes.string,
};
DarkPopOver.defaultProps = {
  options: {},
  handleChange: () => null,
  className: 'search-box position-relative',
  icon: <></>,
  language: PropTypes.object,
  boxColor: 'bg-white',
  boxSelectedColor: 'bg-primary-dark-darker',
  selectedValue: '',
  popOverTop: '48px',
};
function mapStateToProps(state) {
  return {
    language: state.language,
  };
}
export default connect(mapStateToProps)(DarkPopOver);
